import { useCallback, useMemo, useState } from 'react';
import { SelectMenu, Button } from '@scale/scaleui';
import { InteractionStepType, TransformedResponseKey } from '@scale/shared/types/chat';
import uuid from 'uuid';
import { StepConfigurationComponentProps } from 'react-scale/components/scalers/tasks/ThreadedInteraction/definitions';

function OverrideIDBuilder({
  params: currentParams,
  setParams: setCurrentParams,
}: Omit<StepConfigurationComponentProps<InteractionStepType>, 'property' | 'templateVariables'>) {
  const [lastId, setLastId] = useState<string>();

  const { keyOptions, options } = useMemo(() => {
    const keyOptions = Object.values(TransformedResponseKey);
    const options = [
      {
        id: '',
        name: 'Select an option',
      },
      ...keyOptions.map(key => ({ name: key, id: key })),
    ];
    return { keyOptions, options };
  }, []);

  const resetOverride = useCallback(
    () => setCurrentParams({ ...currentParams, id: lastId ?? uuid.v4(), override_id: false }),
    [currentParams, lastId, setCurrentParams],
  );

  return (
    <>
      {currentParams.override_id && (
        <div className="flex flex-row align-center">
          <SelectMenu
            label={'Override Step ID (for response parsing convenience)'}
            options={options}
            selectedOptionId={
              keyOptions.includes(currentParams.id as TransformedResponseKey)
                ? currentParams.id
                : ''
            }
            setSelected={(id: string) => {
              if (!id) return resetOverride();

              if (!keyOptions.includes(currentParams.id as TransformedResponseKey)) {
                setLastId(currentParams.id);
              }
              setCurrentParams({
                ...currentParams,
                id,
                override_id: true,
              });
            }}
          />
          <div className="flex items-end">
            <Button
              onClick={resetOverride}
              disabled={!currentParams.override_id}
              variant="warning"
              className="ml-8 mb-1"
            >
              Reset Override
            </Button>
          </div>
        </div>
      )}
    </>
  );
}

export default OverrideIDBuilder;
